import { AuthService } from "./auth.service.interface";
import ConnectApi from "./legacy/connect.api";
import { MenuContextInterface } from "@menu/core/menu-context.interface";

class ConnectService implements AuthService {
    private _service: ConnectApi;
    private _context: MenuContextInterface;
    private _useSelfServiceAfrica = false;

    constructor(context: MenuContextInterface) {
        const { settings } = context;

        this._context = context;

        this._useSelfServiceAfrica = settings.useSelfServiceAfrica;

        this._service = new ConnectApi(context);
    }

    signIn() {
        this._service.signIn();
    }

    async signOut() {
        this._context.updateIsLoggedIn(false);

        if (this._useSelfServiceAfrica) {
            return;
        }

        await this._service.signOutAsync();

        window.location.reload();
    }

    getSignInUrl = () => {
        return this._service.getSignInUrl();
    }

    getSignOutUrl = () => {
        return this._service.getSignOutUrl();
    }
}

export default ConnectService;